import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'save-languages-modal',
	template: require('./save-languages-modal.html'),
	styles: [require('./save-languages-modal.scss')]
})
export class SaveLanguagesModalComponent {
	@Input() text = '';
	@Input() redirect = false;
	constructor(private activeModal: NgbActiveModal) {}

	closeModal(state): void {
		this.activeModal.close(state);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.ts